import React from 'react';
import { getErrorMessage, type FallbackProps } from "react-error-boundary";

const ErrorFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => {

    // TODO: not yet sure this is needed or not
    // const history = useHistory();
    // history.listen(() => {
    //     if (typeof resetErrorBoundary === 'function') {
    //         resetErrorBoundary();
    //     }
    // });

    return (
        <div role="alert" className="alert alert-danger">
            <h2>Something went wrong.</h2>
            <pre>{getErrorMessage(error) ?? 'Unknown error'}</pre>
        </div>
    )
};

export default ErrorFallback;
